import '../../styles/main.scss';
import '../../styles/pages/kiosk-station-detail.scss';
import { i18n } from '../../../i18n/i18n.js';
import { componentLoader } from '../components/loadComponents.js';
import { setupNavigation } from '../utils/navMenu.js';
import { sectionReveal } from '../utils/scrollReveal.js';
import { initProductCarousel } from '../utils/productCarousel.js';
import { initRelatedSlider } from '../components/relatedSlider.js';
import { initAccordion } from '../components/accordion.js';
import { kioskStationConfig } from '../data/productConfig.js';

window.i18n = i18n;

document.addEventListener('DOMContentLoaded', async () => {
  await componentLoader.loadAllComponents();
  setupNavigation();
  await i18n.init();
  const sections = document.querySelectorAll('section');
  sectionReveal.reveal(Array.from(sections));

  const slotOptionsWrap = document.querySelector('.product-detail-config__slot-options');
  const slotOptions = Array.from(document.querySelectorAll('.product-detail-config__slot-option'));
  const slotsLabel = document.querySelector('.product-detail-config__slots-label');

  const posOptions = Array.from(document.querySelectorAll('.product-detail-config__pos-option'));
  const posLabel = document.querySelector('.product-detail-config__pos-label');

  const scrollOptionIntoEnd = (el) => {
    if (!slotOptionsWrap || !el) return;
    const styles = getComputedStyle(slotOptionsWrap);
    const paddingLeft = parseFloat(styles.paddingLeft) || 0;
    const paddingRight = parseFloat(styles.paddingRight) || 0;
    const maxScroll = Math.max(0, slotOptionsWrap.scrollWidth - slotOptionsWrap.clientWidth);
    const targetLeft = el.offsetLeft + el.offsetWidth - (slotOptionsWrap.clientWidth - paddingRight) - paddingLeft;
    const finalLeft = Math.max(0, Math.min(targetLeft, maxScroll));
    slotOptionsWrap.scrollTo({ left: finalLeft, behavior: 'smooth' });
  };

  const mainImage = document.querySelector('.product-detail-config__main-image .panel img');
  const mainPicture = document.querySelector('.product-detail-config__main-image .panel picture');
  const mainSources = mainPicture ? Array.from(mainPicture.querySelectorAll('source')) : [];
  const dotsWrap = document.querySelector('.product-detail-config__main-image .gallery-dots');
  const prevBtn = document.querySelector('.product-detail-config__main-image .gallery-arrow--prev');
  const nextBtn = document.querySelector('.product-detail-config__main-image .gallery-arrow--next');

  let currentGallery = [];
  let currentIndex = 0;

  const updateGalleryDisplay = () => {
    if (!mainImage || !currentGallery.length) return;
    const item = currentGallery[currentIndex];
    mainImage.src = item.src;
    mainImage.alt = item.alt || 'Product image';
    if (mainSources.length && item.srcset) {
      mainSources.forEach(s => { s.srcset = item.srcset; });
    }
    if (dotsWrap) {
      Array.from(dotsWrap.children).forEach((dot, i) => {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }
  };

  const renderGallery = (images) => {
    currentGallery = images;
    currentIndex = 0;
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      images.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'dot' + (i === 0 ? ' is-active' : '');
        dot.addEventListener('click', () => {
          currentIndex = i;
          updateGalleryDisplay();
        });
        dotsWrap.appendChild(dot);
      });
    }
    updateGalleryDisplay();
  };

  const selectOptionByIndex = (idx) => {
    const option = slotOptions[idx];
    if (!option) return;
    slotOptions.forEach(opt => opt.classList.remove('is-active'));
    option.classList.add('is-active');
    scrollOptionIntoEnd(option);
    
    const slots = option.dataset.slots;
    const config = kioskStationConfig[slots];
    
    if (slotsLabel && config) {
      slotsLabel.textContent = config.variantName;
    }
    
    if (config && config.gallery) {
      renderGallery(config.gallery);
    }
  };

  const selectPosByIndex = (idx) => {
    const option = posOptions[idx];
    if (!option) return;
    posOptions.forEach(opt => opt.classList.remove('is-active'));
    option.classList.add('is-active');
    
    const posValue = option.dataset.pos;
    if (posLabel) {
      posLabel.textContent = `POS - ${posValue}`;
    }
  };

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      if (currentGallery.length === 0) return;
      currentIndex = (currentIndex - 1 + currentGallery.length) % currentGallery.length;
      updateGalleryDisplay();
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      if (currentGallery.length === 0) return;
      currentIndex = (currentIndex + 1) % currentGallery.length;
      updateGalleryDisplay();
    });
  }
  // 初始化：选择默认活跃项
  const activeIndex = slotOptions.findIndex(opt => opt.classList.contains('is-active'));
  if (activeIndex >= 0) {
    selectOptionByIndex(activeIndex);
  } else if (slotOptions.length > 0) {
    selectOptionByIndex(0);
  }

  // 绑定点击事件
  slotOptions.forEach((option, idx) => {
    option.addEventListener('click', () => {
      selectOptionByIndex(idx);
    });
  });

  posOptions.forEach((option, i) => {
    option.addEventListener('click', () => selectPosByIndex(i));
  });
  selectPosByIndex(0);

  initRelatedSlider();
  initProductCarousel('#placementTrack');
  initAccordion('.accordion', {
    multiple: false,
    defaultOpen: 0,
  });
});
